const SEARCH_FIELD = {
    TO_DATE: "to_date",
    FROM_DATE: "from_date",
    STATUS: "status",
    SEARCH_KEYWORD: "search_keyword"
};

const STOCK = 1;
const ORDER = 2;
const KDS = 3;

const ORDER_STATUS = {
    PREPARING: 1,
    READY: 2,
    PENDING: 0
};

export { SEARCH_FIELD, STOCK, ORDER, KDS, ORDER_STATUS };